
import { async_command_dispatcher } from "@/api/client"

export class SetAccDateDoneManuallyCommand {
    constructor(
        private screen_data: {ui_accDate_loading:boolean},
    ) {}

    async run(invoice_ids: Array<number>, accounting_date: string) {
        this.screen_data.ui_accDate_loading = true
        let args = {invoice_ids: invoice_ids, accounting_date: accounting_date}
        let resOutput
        try {
            resOutput = await async_command_dispatcher.dispatch_with_result('set.acc.date.done.manually', args, 1000)
        } catch (error) {
            console.error('Error updating accounting date in "done_manually"', error)
            resOutput = null
        }
        this.screen_data.ui_accDate_loading = false

        if (!resOutput) return null
        else if (typeof resOutput == "string" && resOutput === "wrong_date") return "wrong_date"
        else if (Array.isArray(resOutput)) return resOutput
        return null
    }
}